import { Component, ElementRef, EventEmitter, HostListener, Input, Output, signal, ViewChild } from '@angular/core';
import { SideNavServiceService } from 'src/app/service/side-nav-service.service';
import { KtdGridBackgroundCfg, KtdGridComponent, KtdGridLayout } from '@katoid/angular-grid-layout';
import { chipData1, chipData2, dashboardMock, GetTable, tableData1, tableData2 } from 'src/app/mock';
import { dashboardTourValues } from 'src/environments/environment';
import { Globals } from 'src/app/service/global';
import { DashboardService } from 'src/app/service/dashboard.service';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { LoginService } from 'src/app/service/login.service';
import { MatDialog } from '@angular/material/dialog';
// import { AdcTableComponent } from '../adc-table/adc-table.component';
import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { ReportService } from 'src/app/service/report.service';
import { Console } from 'console';
import { start } from 'repl';
import { DrillDownPreviewComponent } from '../drill-down-preview/drill-down-preview.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { trigger, transition, query, style, stagger, animate } from '@angular/animations';
import { debounceTime } from 'rxjs/operators';
import { data } from 'jquery';
import { bottom } from '@katoid/angular-grid-layout/lib/utils/react-grid-layout.utils';
import { left } from '@popperjs/core';
@Component({
  selector: 'app-grid-dashboard',
  templateUrl: './grid-dashboard.component.html',
  styleUrl: './grid-dashboard.component.css',
  animations: [
    trigger('listAnimation', [
      transition('* => *', [  // runs on any change to the bound list
        query(':enter', [
          style({ opacity: 0, transform: 'translateX(-100%)' }),
          stagger(100, [
            animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
          ])
        ], { optional: true }),
        // optionally animate leaving items
        query(':leave', [
          stagger(50, [
            animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' }))
          ])
        ], { optional: true })
      ])
    ])
  ]
})
export class GridDashboardComponent {
  @Input() vizType: any = "bar";
  @Input() rowHeightFit = false;
  @Input() gridHeight: null | number = null;
  @Input() cols: number = 12;
  @Input() rowHeight: number = 44;
  @Input() dragStartThreshold = 0;
  @Input() autoScroll = true;
  @Input() disableDrag = false;
  @Input() showBackground = true
  @Input() disableResize = false;
  @Input() disableRemove = true;
  @Input() gap = 8;
  @Input() autoResize = true;
  @Input() preventCollision = true;
  @Input() isDragging = false;
  @Input() isResizing = false;

  option = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      top: '5%',
      left: 'center'
    },
    series: [
      {
        name: 'Access From',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: '#fff',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 30,
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: 1048, name: 'meeting' },
          { value: 735, name: 'Upcoming Meeting' },
          { value: 580, name: 'Followup Meeting' },
          { value: 484, name: 'Cancelled Meeting' },
          // { value: 300, name: 'Video Ads' }
        ]
      }
    ]
  };



  @Output() savedLayout!: EventEmitter<any>;
  isExtraSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.XSmall
  );
  isMedium: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Medium
  )
  isSmall: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Small
  )
  showIconsSet = new Set<number>();
  selectedCategory: string | null = null;
  showFilter: boolean = false;
  openMenuId: number | null = null;
  editDashboard: boolean = false;
  currentPlaceholder: any = "Custom 1";
  currentDashboardObj: any;
  actualLayout: any;
  addDropdown: boolean = false;
  addDropdown2: boolean = false;
  addDropdown3: boolean = false;
  addOptions = signal<any>(false);
  showReportMenu: boolean = false;
  searchTerm: string = "";
  groupedKeys: any;
  groupedReports: any;
  reportList: any = [];
  defaultFilters: any;
  deviceXs!: boolean;
  deviceSm!: boolean;
  deviceMd!: boolean;
  deviceLg!: boolean;
  deviceXl!: boolean;
  mediaSub!: Subscription;
  meetingCount = 0;
  currentComponent = "upcoming";
  meetingType = "my";
  meetingPeriod = "today"
  startDate: string = '2025-05'; // Default start date (YYYY-MM)
  endDate: string = '2025-10';  // Default end date (YYYY-MM)
  chartOptions: any;
  // meetingData: any[] = [];
  loginName: any = "mlakshmi";
  loginKey: any = localStorage.getItem('loginKey');
  // loginKey: any = "k2cR92iorziYv+whk8vgGA==";
  // loginKey = "k2cR92iorziYv+whk8vgGA=="
  reload = false;
  gridDrillArr = [{
    "colAlias": "ORGCODE",
    "condition": "~eq~",
    "operator": "AND",
    "startBrace": "(",
    "endBrace": ")",
    "conditionValue": "CHN",
    "conditionType": "",
    "conditionCategory": "",
    "conditionConstant": ""
  }]
  // meetingResponse = [
  //   { "Month": 12, "MEETINGHISSTATUS": 1036, "Year": 2024, "count_MEETING_ID_": 47 },
  //   { "Month": 12, "MEETINGHISSTATUS": 1037, "Year": 2024, "count_MEETING_ID_": 29 },
  //   { "Month": 12, "MEETINGHISSTATUS": 1038, "Year": 2024, "count_MEETING_ID_": 38 },
  //   { "Month": 12, "MEETINGHISSTATUS": 1039, "Year": 2024, "count_MEETING_ID_": 53 },
  //   { "Month": 12, "MEETINGHISSTATUS": 1040, "Year": 2024, "count_MEETING_ID_": 18 },
  //   { "Month": 12, "MEETINGHISSTATUS": 1041, "Year": 2024, "count_MEETING_ID_": 17 }
  // ];
  meetingResponse: any;
  taskResponse = [
    {
      overduetask: 25,
      month: 12,
      year: 2024,
      pendingtask: 70,
      completed: 40
    },
    {
      overduetask: 13,
      month: 1,
      year: 2025,
      pendingtask: 49,
      completed: 25
    }
  ];


  meetingStatuses = [1036, 1037, 1038, 1039, 1040, 1041];
  barChartOptions = {
    title: {
      text: 'Tasks Overview (Last 6 Months)',
      left: 'center'
    },
    tooltip: {
      trigger: 'axis'
    },
    legend: {
      data: ['Completed', 'Pending', 'Overdue'],
      bottom: 0
    },
    xAxis: {
      type: 'category',
      data: ['Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan']
    },
    yAxis: {
      type: 'value'
    },
    series: [
      {
        name: 'Completed',
        type: 'bar',
        data: [120, 200, 150, 80, 70, 110],
        itemStyle: {
          color: '#4caf50'
        }
      },
      {
        name: 'Pending',
        type: 'bar',
        data: [60, 90, 50, 30, 20, 40],
        itemStyle: {
          color: '#ffeb3b'
        }
      },
      {
        name: 'Overdue',
        type: 'bar',
        data: [30, 20, 10, 40, 50, 60],
        itemStyle: {
          color: '#f44336'
        }
      }
    ]
  };

  taskCountChipData: any;

  taskData: any
  meetingCountChipData: any
  tableList: any = [
    {
      id: 1,
      label: 'Table Data Sample 1',
      data: tableData1
    },
    {
      id: 2,
      label: 'Table Data Sample 2',
      data: tableData2
    },
  ];

  cardList: any = [
    {
      id: 1,
      label: 'Card Data 1',
      data: chipData1
    },
    {
      id: 1,
      label: 'Card Data 2',
      data: chipData2
    },
  ];
  gridBackgroundConfig: Required<KtdGridBackgroundCfg> = {
    show: 'never',
    borderColor: 'rgba(255, 128, 0, 0.25)',
    gapColor: 'rgba(128, 128, 128, 0.25)',
    borderWidth: -1,
    rowColor: 'rgba(255, 255, 255, 0.10)',
    columnColor: 'rgba(255, 255, 255, 0.10)',
  };
  paneOpts: any = [
    {
      id: 1,
      label: 'PDF'
    },
    {
      id: 2,
      label: 'EXCEL'
    },
    {
      id: 3,
      label: 'JPG'
    },
  ]
  public layout: any[] = [];
  transitions: { name: string, value: string }[] = [
    { name: 'ease', value: 'transform 500ms ease, width 500ms ease, height 500ms ease' },
    { name: 'ease-out', value: 'transform 500ms ease-out, width 500ms ease-out, height 500ms ease-out' },
    { name: 'linear', value: 'transform 500ms linear, width 500ms linear, height 500ms linear' },
    {
      name: 'overflowing',
      value: 'transform 500ms cubic-bezier(.28,.49,.79,1.35), width 500ms cubic-bezier(.28,.49,.79,1.35), height 500ms cubic-bezier(.28,.49,.79,1.35)'
    },
    { name: 'fast', value: 'transform 200ms ease, width 200ms linear, height 200ms linear' },
    { name: 'slow-motion', value: 'transform 1000ms linear, width 1000ms linear, height 1000ms linear' },
    { name: 'transform-only', value: 'transform 500ms ease' },
  ];
  currentTransition: string = this.transitions[0].value;
  showTableOptions: boolean = false;
  showCardOptions: boolean = false;
  dropdownData: any = {
    "id": "1",
    "theme": "blue",
    "defaultLabel": "Dropdown",
    "showIcon": true,
    "icon": 'keyboard_arrow_down',
    "list": [
      {
        "id": "1",
        "label": "None",
      },
      {
        "id": "2",
        "label": "Address filter",
      },
      {
        "id": "3",
        "label": "Age between 30 t0 32",
      },
      {
        "id": "4",
        "label": "City in specific",
      },
      {
        "id": "5",
        "label": "My filter",
      },
      {
        "id": "6",
        "label": "Age filter from 12 to 14",
      }
    ]
  };

  //button
  btnAction: any = ['My Meeting', 'Other Meeting'];
  btnActive: string = 'My Meeting';
  meeting = [
    {
      label: "Meeting",
      img: "line-chart",
      data: [
        {
          total: 2,
          hours: 4,
          name: 'Today',
          active: true
        },
        {
          total: 8,
          hours: 30,
          name: 'Week'
        },
        {
          total: 8,
          hours: 30,
          name: 'Month'
        }
      ]
    },
    {
      label: "Task",
      img: "line-chart",
      data: [
        {
          total: 2,
          hours: 4,
          name: 'Today',
          active: true
        },
        {
          total: 8,
          hours: 30,
          name: 'Week'
        },
        {
          total: 8,
          hours: 30,
          name: 'Month'
        }
      ]
    },
    {
      label: "Followup Meeting",
      img: "line-chart",
      data: [
        {
          total: 2,
          hours: 4,
          name: 'Today',
          active: true
        },
        {
          total: 8,
          hours: 30,
          name: 'Week'
        },
        {
          total: 8,
          hours: 30,
          name: 'Month'
        }
      ]
    },
    // {
    //   label:"Frequently Cancelled",
    //   img:"line-chart",
    //   data:[
    //     {
    //     total:2,
    //     hours:4,
    //     name:'Today'
    //   },
    //   {
    //     total:8,
    //     hours:30,
    //     name:'week'
    //   },
    //   {
    //     total:8,
    //     hours:30,
    //     name:'month'
    //   }
    // ]
    // }
  ]

  //upcoming meeting

  upcomingMeeting: any[] = [
    {
      name: "Jhon",
      createdBy: "Sam",
      timeRemaining: "1 hr"
    },
    {
      name: "Smith",
      createdBy: "Sam",
      timeRemaining: "1 hr"
    },
    {
      name: "Larry",
      createdBy: "Sam",
      timeRemaining: "1 hr"
    }
  ]


  meetingCountoption = {
    label: "Last 6 Months Meeting Types",
    type: "meeting",
    legend: {
      bottom: '0',
      left: 'center'
    },
    tooltip: {},
    dataset: {
      dimensions: ['product', 'Completed', 'Pending', 'Upcoming'],
      source: [
        { product: 'May', Completed: 43.3, Pending: 85.8, Upcoming: 93.7 },
        { product: 'Jun', Completed: 83.1, Pending: 73.4, Upcoming: 55.1 },
        { product: 'July', Completed: 86.4, Pending: 65.2, Upcoming: 82.5 },
        { product: 'Aug', Completed: 72.4, Pending: 53.9, Upcoming: 39.1 },
        { product: 'Aug', Completed: 72.4, Pending: 53.9, Upcoming: 39.1 },
        { product: 'Sep', Completed: 72.4, Pending: 53.9, Upcoming: 39.1 },
        { product: 'Oct', Completed: 72.4, Pending: 53.9, Upcoming: 39.1 }
      ]
    },
    xAxis: { type: 'category' },
    yAxis: {},
    // Declare several bar series, each will be mapped
    // to a column of dataset.source by default.
    series: [{ type: 'bar' }, { type: 'bar' }, { type: 'bar' }]
  };

  //table 
  //Grid Layout changes
  backgroundConfig = defaultBackgroundConfig;
  response = dashboardMock;
  tableData: any = GetTable;
  organizationList: any = [
    {
      orgName: "Aithent Chennai",
      orgCode: "CHN",
      orgId: "70",
      country: "India",
      parentOrgName: "Aithent Inc.,",
      parentOrgCode: "NY",
      isVisible: "1",
      isDefault: "1",
      orgType: "C"
    }
  ];
  selectedOrganization: any = { orgName: "Aithent Chennai", orgCode: "CHN" };
  orgdropdown = signal<boolean>(false);
  @ViewChild('gridComp') gridComp!: KtdGridComponent;
  @ViewChild('parentScrollgrid', { static: true }) gridContainer!: ElementRef;
  resizeObserver!: ResizeObserver;



  // @HostListener('window:resize', ['$event'])
  // onResize() {
  //   this.forceGridRefresh();
  // }

  forceGridRefresh() {
    // this.layout = this.mergeLayoutUpdates(this.layout, this.layout);
    this.gridComp.cols = this.gridComp.cols; // Triggers re-render
    // this.gridComp.resize()
    (this.gridComp as any).updateGridContainerSize?.();
  }
  constructor(public sideNavService: SideNavServiceService, private globals: Globals, private dashboard: DashboardService, public mediaObserver: MediaObserver, private loginService: LoginService, private dialog: MatDialog, private readonly breakpointObserver: BreakpointObserver, private reportService: ReportService, private spinner: NgxSpinnerService) {
    // this.response.data.results.dashboardConfig = [{}];
    // this.selectedOrganization =  localStorage.getItem('orgCode');


    //  this.loginName = localStorage.getItem('loginName');
    //  this.loginKey = localStorage.getItem('loginKey');
    //  if(this.loginName == 'msaranraj'){
    //    this.loginKey = "fbe5yzd8/zqmjK3bHsKEsA=="
    //  }
    //  if(this.loginName == 'nvgopal'){
    //    this.loginKey = "KYSNjlLGqpcD8BKzjXE/eg=="
    //  }
    //  if(this.loginName == 'mlakshmi'){
    //    this.loginKey = "+ATs8Vicq5L9EeZgPv0kig=="
    //  }
    var meetingJSON = {
      "delay": "10",
      "displayConfig": this.globals.settingValuesList.UPCOMING_MEETING_CONF,
      // "meetingStatus": [
      //   18,648
      // ],
      "startDelay": "60",
      "userId": this.globals.userId,
      "startDate": "",
      "endDate": "",
      "visitorTimeZone": this.globals.vTimeZone,
      "filterCol": ""
    }

    var req = {
      dashboardMetaDataCode: "AG"
    }

    //  this.reportService.getportletData(req).subscribe((data:any)=>{
    //        data.body.forEach((element:any)=>{
    //           var reportReq = {
    //             url : element.portletConfigDataSrcDetails.url,
    //             type : element.portletConfigDataSrcDetails.apiMethod,
    //             parameters : 

    //           }
    //        })
    //  })






    // dashboard.documentMeetingCount(meetingJSON).subscribe(data => {
    //   this.meetingCount = data.totalCount;
    // })

    var a = {
      loginName: this.loginName,
      loginKey: this.loginKey,
      templateCode: "SYS_mymeetings_bystatus_2",
      gridDrillArr: this.gridDrillArr
    }

    // this.reportService.getDashBoardMeetingCount(a).subscribe((data: any) => {
    //   this.meetingCountChipData = data.body;
    // })


    //based on org code and userid need to fetch count

    //  if(this.meetingType='my'){
    //       this.
    //  }
  }

  //   @HostListener('window:resize')
  // onResize() {
  //   this.gridHeight = window.innerHeight - 100; // or your container height
  // }

  ngOnInit() {
    // this.spinner.show();
    this.response.data.results.dashboardConfig = [];
    this.gridHeight = window.innerHeight - 100;

    // this.loginService.getOrganization(localStorage.getItem('loginName') + "").subscribe((data: any) => {
    //   this.organizationList = data.body;
    // });
    this.gridDrillArr = [{
      "colAlias": "ORGCODE",
      "condition": "~eq~",
      "operator": "AND",
      "startBrace": "(",
      "endBrace": ")",
      "conditionValue": this.selectedOrganization?.orgCode,
      "conditionType": "",
      "conditionCategory": "",
      "conditionConstant": ""
    }]
    this.reload = true;
    var meeting: any = {
      "dashboardConfigId": 546,
      "dashboardId": 72,
      "reportId": 0,
      "rows": 6,
      "columns": 10,
      "cardSettings": "task",
      "cardType": "chips",
      "xposition": 0,
      "yposition": 0
    }
    var task = {
      "dashboardConfigId": 547,
      "dashboardId": 72,
      "reportId": 0,
      "rows": 6,
      "columns": 10,
      "cardSettings": "meeting",
      "cardType": "chips",
      "xposition": 6,
      "yposition": 0
    }
    const Annoucement = {
      "dashboardConfigId": 548,
      "dashboardId": 72,
      "reportId": 0,
      "rows": 12,
      "columns": 3,
      "cardSettings": "meeting",
      "cardType": "Annoucement",
      "xposition": 0,
      "yposition": 6
    }

    // const card = {
    // "dashboardConfigId": 596,
    // "dashboardId": 72,
    // "reportId": 0,
    // "rows": 12,
    // "columns": 6,
    // "cardSettings":this.meeting,
    // "cardType": "meeting",
    // "xposition": 0,
    // "yposition": 0
    // }
    // const taskData = {
    //   "dashboardConfigId": 596,
    // "dashboardId": 72,
    // "reportId": 0,
    // "rows": 3,
    // "columns": 4,
    // "cardSettings": this.meeting,
    // "cardType": "task",
    // "xposition": 4,
    // "yposition": 3
    // }

    // const upcoming = {
    //   "dashboardConfigId": 597,
    //   "dashboardId": 72,
    //   "reportId": 0,
    //   "rows": 6,
    //   "columns": 8,
    //   "cardSettings": "",
    //   "cardType": "upcomingMeeting",
    //   "xposition": 0,
    //   "yposition": 6
    //   }

    // const pieCharts = {
    //   "dashboardConfigId": 598,
    //   "dashboardId": 72,
    //   "reportId": 0,
    //   "rows": 6,
    //   "columns": 8,
    //   "cardSettings": this.option,
    //   "cardType": "chart",
    //   "xposition": 6,
    //   "yposition": 6
    //   }
    this.response.data.results.dashboardConfig.push(meeting);
    // this.response.data.results.dashboardConfig.push(card);
    this.response.data.results.dashboardConfig.push(Annoucement);
    // this.response.data.results.dashboardConfig.push(taskData);
    this.response.data.results.dashboardConfig.push(task);

    // this.response.data.results.dashboardConfig.push(upcoming);
    // this.response.data.results.dashboardConfig.push(pieCharts);




    this.layout = this.transformDashboardObjToLayout(this.response.data.results.dashboardConfig);


    this.initializeChart();

    var req = {
      loginName: this.loginName,
      loginKey: this.loginKey,
      templateCode: "SYS_new_task_cpunt_sixmonth_75",
      gridDrillArr: this.gridDrillArr
    }
    this.reportService.getPhemeReportData(req).subscribe((data: any) => {
      //   const data =  [
      //     {
      //         "overduetask": 4,
      //         "ORGCODE": "CHN",
      //         "month": 4,
      //         "year": 2025,
      //         "pendingtask": 4,
      //         "completed": 0
      //     },
      //     {
      //         "overduetask": 9,
      //         "ORGCODE": "CHN",
      //         "month": 5,
      //         "year": 2025,
      //         "pendingtask": 10,
      //         "completed": 1
      //     }
      // ]

      const barChartData = this.transformBarChartData(data.body, new Date().toLocaleDateString("en-US").toString());
      var barChart = {
        "dashboardConfigId": 549,
        "dashboardId": 72,
        "reportId": 0,
        "rows": 6,
        "columns": 10,
        "cardSettings": barChartData,
        "cardType": "chart",
        "xposition": 0,
        "yposition": 0
      }
      this.spinner.hide();
      this.response.data.results.dashboardConfig.push(barChart);
      this.layout = this.transformDashboardObjToLayout(this.response.data.results.dashboardConfig);
    })

    // Current date
    this.mediaSub = this.mediaObserver.asObservable().subscribe((changes: MediaChange[]) => {
      changes.forEach((result) => {
        this.deviceXs = result.mqAlias === 'xs' ? true : false
        this.deviceSm = result.mqAlias === 'sm' ? true : false
        this.deviceMd = result.mqAlias === 'md' ? true : false
        this.deviceLg = result.mqAlias === 'lg' ? true : false
        this.deviceXl = result.mqAlias === 'xl' ? true : false
      });
    });
    this.savedLayout = new EventEmitter<any>();
    this.currentDashboardObj = this.response.data.results;

    var a = {
      loginName: this.loginName,
      loginKey: this.loginKey,
      templateCode: "SYS_task_count_79",
      gridDrillArr: this.gridDrillArr
    }

    // this.reportService.getDashBoardTaskCount(a).subscribe((data: any) => {
    //   this.taskCountChipData = data.body;
    //   var taskData = {
    //     "dashboardConfigId": 546,
    //     "dashboardId": 72,
    //     "reportId": 0,
    //     "rows": 7,
    //     "columns": 5,
    //     "cardSettings": "task",
    //     "cardType": "chips",
    //     "xposition": 0,
    //     "yposition": 0
    //   }
    //   this.response.data.results.dashboardConfig.push(taskData);
    //   this.layout = this.transformDashboardObjToLayout(this.response.data.results.dashboardConfig);

    // }) 






    // var meetingData = {
    //   "dashboardConfigId": 596,
    //   "dashboardId": 72,
    //   "reportId": 0,
    //   "rows": 7,
    //   "columns": 5,
    //   "cardSettings": "meeting",
    //   "cardType": "chips",
    //   "xposition": 0,
    //   "yposition": 0
    // }


    // this.response.data.results.dashboardConfig.push(meetingData);
    this.layout = this.transformDashboardObjToLayout(this.response.data.results.dashboardConfig);
    this.defaultFilters = this.response.data.results.filterData;
    this.disableDrag = true;
    this.showBackground = true;
    this.disableResize = true;
    this.disableRemove = true;
    // this.showFilter = true;
    // }) 
  }

  ngAfterViewInit() {
    // this.resizeObserver = new ResizeObserver(() => {
    //   this.forceGridRefresh();
    // });

    // this.resizeObserver.observe(this.gridContainer.nativeElement);
    fromEvent(window, 'resize')
      .pipe(debounceTime(200))
      .subscribe(() => this.gridComp.resize())
  }


  getLiveDate() {
    return new Date().toLocaleDateString("en-US").toString();
  }


  initializeChart() {
    this.chartOptions = {
      title: {
        text: 'Meeting Types Over the Last 6 Months',
      },
      tooltip: {
        trigger: 'axis',
      },
      legend: {
        data: [],  // This will be dynamically populated based on meeting statuses
        bottom: 0,
      },
      xAxis: {
        type: 'category',
        data: [],  // This will be dynamically populated with months
      },
      yAxis: {
        type: 'value',
        name: 'Meeting Count',
      },
      series: [],  // This will be dynamically populated with series data
    };

    // Populate chart data based on response
    this.updateChart();
  }

  updateChart() {
    // Generate the x-axis months between start and end date
    const months = this.getMonthsBetween(this.startDate, this.endDate);
    const meetingCounts = this.initializeMeetingCounts(months);
    var req = {
      loginName: this.loginName,
      loginKey: this.loginKey,
      templateCode: "SYS_lastsixmonthmeetingcount_66",
      gridDrillArr: this.gridDrillArr
    }

    this.reportService.getPhemeReportData(req).subscribe((data: any) => {
      this.meetingResponse = data.body;
      // this.meetingResponse =  [
      //   {
      //       "ORGCODE": "CHN",
      //       "Month": 4,
      //       "MEETINGHISSTATUS": 1036,
      //       "Year": 2025,
      //       "count_MEETING_ID_": 13
      //   },
      //   {
      //       "ORGCODE": "CHN",
      //       "Month": 4,
      //       "MEETINGHISSTATUS": 1037,
      //       "Year": 2025,
      //       "count_MEETING_ID_": 4
      //   },
      //   {
      //       "ORGCODE": "CHN",
      //       "Month": 4,
      //       "MEETINGHISSTATUS": 1038,
      //       "Year": 2025,
      //       "count_MEETING_ID_": 17
      //   },
      //   {
      //       "ORGCODE": "CHN",
      //       "Month": 4,
      //       "MEETINGHISSTATUS": 1039,
      //       "Year": 2025,
      //       "count_MEETING_ID_": 10
      //   },
      //   {
      //       "ORGCODE": "CHN",
      //       "Month": 4,
      //       "MEETINGHISSTATUS": 1040,
      //       "Year": 2025,
      //       "count_MEETING_ID_": 2
      //   },
      //   {
      //       "ORGCODE": "CHN",
      //       "Month": 4,
      //       "MEETINGHISSTATUS": 1041,
      //       "Year": 2025,
      //       "count_MEETING_ID_": 1
      //   }
      // ]

      this.spinner.hide();
      // Prepare the series names and data
      const seriesData = this.meetingStatuses.map(status => {
        const dataForStatus = this.getMeetingDataForStatus(status, months);
        return {
          name: `${this.globals.meetingStatus.get(status + "")}`,
          type: 'line',
          data: dataForStatus,
        };
      });

      this.chartOptions.xAxis.data = months;
      this.chartOptions.series = seriesData;
      this.chartOptions.legend.data = seriesData.map(series => series.name);
      var a = {
        "dashboardConfigId": 550,
        "dashboardId": 72,
        "reportId": 0,
        "rows": 6,
        "columns": 10,
        "cardSettings": this.chartOptions,
        "cardType": "chart",
        "xposition": 6,
        "yposition": 0
      }
      this.response.data.results.dashboardConfig.push(a);
      this.layout = this.transformDashboardObjToLayout(this.response.data.results.dashboardConfig);
    })

  }

  getMonthsBetween(start: string, end: string): string[] {
    const startDate = new Date(start + '-01');
    const endDate = new Date(end + '-01');
    const months = [];

    while (startDate <= endDate) {
      const month = startDate.toLocaleString('default', { month: 'long' });
      const year = startDate.getFullYear();
      months.push(`${month} ${year}`);
      startDate.setMonth(startDate.getMonth() + 1);
    }

    return months;
  }

  // Initialize meeting counts as zero for each month
  initializeMeetingCounts(months: string[]): any {
    return this.meetingStatuses.reduce((acc: any, status) => {
      acc[status] = months.reduce((monthAcc: any, month) => {
        monthAcc[month] = 0; // Initialize each month with 0
        return monthAcc;
      }, {});
      return acc;
    }, {});
  }

  // Get meeting data for a particular status across all months
  getMeetingDataForStatus(status: number, months: string[]): number[] {
    const dataForStatus = new Array(months.length).fill(0); // Initialize with 0
    this.meetingResponse.forEach((record: any) => {
      if (record.MEETINGHISSTATUS === status) {
        // Format the month key
        const monthKey = `${new Date(record.Year, record.Month - 1).toLocaleString('default', { month: 'long' })} ${record.Year}`;
        const index = months.indexOf(monthKey);

        if (index !== -1) {
          dataForStatus[index] = record.count_MEETING_ID_; // Populate the count for the matching month
        }
      }
    });

    return dataForStatus;
  }

  transformBarChartData(data: any[], startDate: any): any {
    const months = [];
    const date = new Date(startDate);

    // Generate last 6 months
    for (let i = 5; i >= 0; i--) {
      const d = new Date(date.getFullYear(), date.getMonth() - i, 1);
      const month = d.getMonth() + 1; // 1-based month
      const year = d.getFullYear();
      months.push({
        label: d.toLocaleString('default', { month: 'short', year: 'numeric' }), // 'Aug', 'Sep', etc.
        month,
        year
      });
    }

    // Fill data with zeros for missing months
    const completed: any = [];
    const pending: any = [];
    const overdue: any = [];
    const xAxis = months.map(({ label, month, year }) => {
      const found = data.find((d) => d.month === month && d.year === year);

      completed.push(found ? found.completed : 0);
      pending.push(found ? found.pendingtask : 0);
      overdue.push(found ? found.overduetask : 0);

      return label;
    });

    // Return ECharts options
    return {
      label: "Last 6 Months Task Overview",
      type: 'task',
      title: {
        // text: 'Tasks Overview (Last 6 Months)',
        // left: 'center'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['Completed', 'Pending', 'Overdue'],
        bottom: 0
      },
      xAxis: {
        type: 'category',
        data: xAxis
      },
      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: 'Completed',
          type: 'bar',
          data: completed,
          itemStyle: {
            color: '#4caf50'
          }
        },
        {
          name: 'Pending',
          type: 'bar',
          data: pending,
          itemStyle: {
            color: '#ffeb3b'
          }
        },
        {
          name: 'Overdue',
          type: 'bar',
          data: overdue,
          itemStyle: {
            color: '#f44336'
          }
        }
      ]
    };
  }


  transformTaskData(tasks: any[]) {
    let formattedData: any = { "data": { "Today": {}, "ThisWeek": {}, "ThisMonth": {} } };

    tasks.forEach(task => {
      const taskUserGroup = task.TASKUSERGROUP.replace(' ', '');

      formattedData.data.Today[taskUserGroup] = {
        "taskStatusCounts": {
          "Pending": task.TodayPendingTask,
          "Overdue": task.TodayOverDueTask,
          "Completed": task.TodayCompletedTask
        },
        "totalTasks": task.TodayPendingTask + task.TodayOverDueTask + task.TodayCompletedTask
      };

      formattedData.data.ThisWeek[taskUserGroup] = {
        "taskStatusCounts": {
          "Pending": task.WeeklyPendingTask,
          "Overdue": task.WeeklyOverDueTask,
          "Completed": task.WeeklyCompletedTask
        },
        "totalTasks": task.WeeklyPendingTask + task.WeeklyOverDueTask + task.WeeklyCompletedTask
      };

      formattedData.data.ThisMonth[taskUserGroup] = {
        "taskStatusCounts": {
          "Pending": task.MonthlyPendingTask,
          "Overdue": task.MonthlyOverDueTask,
          "Completed": task.MonthlyCompletedTask
        },
        "totalTasks": task.MonthlyPendingTask + task.MonthlyOverDueTask + task.MonthlyCompletedTask
      };
    });

    return formattedData;
  }



  ngOnDestroy() {
    this.mediaSub.unsubscribe();
    // this.resizeObserver.disconnect();
  }

  transformDashboardObjToLayout(inputArray: any[]): any[] {
    return inputArray.map(input => ({
      id: input?.dashboardConfigId.toString(),
      dashboardConfigId: input?.dashboardConfigId.toString(),
      dashboardId: input.dashboardId,
      reportid: input.reportId,
      w: input.rows,
      h: input.columns,
      type: input.cardType,
      x: input.xposition,
      y: input.yposition,
      // ...(input.cardType === 'heading') ? { minH: 2, minW: 15, } : { minH: 6, minW: 8, },
      // Conditional mapping based on cardType
      ...(input.cardType === 'heading' || input.cardType === 'text'
        ? { content: input.cardSettings }  // Map to 'content' key
        : input.cardType === 'table' || input.cardType == 'chart' || input.cardType == 'chips' || input.cardType == 'task' || input.cardType == 'meeting' ? { data: input.cardSettings } : null   // Map to 'data' key
      )
    }));
  }

  transformLayoutObjToDashboard(inputArray: any[]): any[] {
    return inputArray.map(input => ({
      // ...(input.dashboardId != undefined ? { dashboardConfigId: input?.dashboardId.toString() } : null),
      id: this.currentDashboardObj?.dashboardConfigId.toString(),
      reportId: 0,
      rows: input.w,
      columns: input.h,
      cardType: input.type,
      xposition: input.x,
      yposition: input.y,
      // Conditional mapping based on cardType
      ...(input.type === 'heading' || input.type === 'text'
        ? { cardSettings: input.content }  // Map to 'content' key
        : { cardSettings: JSON.stringify(input.data) }     // Map to 'data' key
      )
    }));
  }

  onLayoutUpdated(updatedLayout: KtdGridLayout) {
    // this.layout = layout;

    this.layout = this.mergeLayoutUpdates(updatedLayout, this.layout);
  }

  mergeLayoutUpdates(updatedLayout: KtdGridLayout, originalLayout: any[]): any[] {
    return originalLayout.map(item => {
      const updatedItem = updatedLayout.find((layoutItem: any) => layoutItem.id === item.id);
      if (updatedItem) {
        return {
          ...item,
          x: updatedItem.x,
          y: updatedItem.y,
          w: updatedItem.w,
          h: updatedItem.h
        };
      }
      return item;
    });
  }

  toggleMenu(id: number): void {
    // if (this.openMenus.has(id)) {
    //   this.openMenus.delete(id);
    // } else {
    //   this.openMenus.add(id);
    // }
    if (this.openMenuId === id) {
      this.openMenuId = null; // Close the menu if it's already open
    } else {
      this.openMenuId = id; // Open the selected menu and close others
    }
  }

  toggleDropdown(dropdown: string) {
    if (dropdown == 'addTextArea') {
      this.addDropdown = !this.addDropdown;
    } else if (dropdown == 'filterType') {
      this.addDropdown2 = !this.addDropdown2;
    } else if (dropdown == 'addFilter') {
      this.addDropdown3 = !this.addDropdown3;
    } else if (dropdown == 'addReport') {
      this.showReportMenu = !this.showReportMenu;
    } else if (dropdown === 'selected') {
      this.addOptions.set(!this.addOptions());
    }
  }

  addTable(table: any) {
    const newLayoutItem: any = {
      id: (this.layout.length + 1).toString(),
      x: 0,
      y: 0,
      w: 30,
      h: 5,
      // minH:2,
      // minW:15,
      // reportId:0,
      // dashboardId: this.currentDashboardObj.dashboardId,
      type: 'table',
      data: table.data
    };
    this.layout = [newLayoutItem, ...this.layout];
    this.showTableOptions = false;
  }

  addCard(card: any) {
    const newLayoutItem: any = {
      id: (this.layout.length + 1).toString(),
      x: 0,
      y: 0,
      w: 16,
      h: 4,
      // minH:2,
      // minW:15,
      // reportId:0,
      // dashboardId: this.currentDashboardObj.dashboardId,
      type: 'chips',
      data: card.data
    };
    this.layout = [newLayoutItem, ...this.layout];
    this.showCardOptions = false;
  }

  addheader() {
    this.toggleDropdown('addTextArea');
    const newLayoutItem: any = {
      id: (this.layout.length + 1).toString(),
      x: 0,
      y: 0,
      w: 30,
      h: 2,
      minH: 2,
      minW: 15,
      reportId: 0,
      dashboardId: this.currentDashboardObj.dashboardId,
      type: 'heading',
      content: ''
    };
    const dashboard = this.currentDashboardObj;
    dashboard.dashboardConfig = this.transformLayoutObjToDashboard([newLayoutItem]);
    // this.dashboardService.addReportstoDashboard(dashboard).subscribe(response => {
    //   newLayoutItem.dashboardConfigId= response.data.results.dashboardConfigId[0];
    // });

    this.layout = [newLayoutItem, ...this.layout];
  }

  /**
   * function for adding new text to the dashboard
   */
  addDescription() {
    this.toggleDropdown('addTextArea');
    const newLayoutItem: any = {
      id: (this.layout.length + 1).toString(),
      x: 0,
      y: 0,
      w: 9,
      h: 7,
      minH: 5,
      dashboardId: this.currentDashboardObj.dashboardId,
      minW: 5,
      reportId: 0,
      type: 'text'
    };
    const dashboard = this.currentDashboardObj;
    dashboard.dashboardConfig = this.transformLayoutObjToDashboard([newLayoutItem]);
    // this.dashboardService.addReportstoDashboard(dashboard).subscribe(response => {
    //   newLayoutItem.dashboardConfigId= response.data.results.dashboardConfigId[0];
    // });
    this.layout = [newLayoutItem, ...this.layout];
  }

  addReport(reportId: any, reportType: any) {
    this.toggleDropdown('addReport');
    const newLayoutItem: any = {
      id: (this.layout.length + 1).toString(),
      x: 0,
      y: 0,
      w: 9,
      dashboardId: this.currentDashboardObj.dashboardId,
      h: 7,
      type: reportType,
      reportid: reportId
    };
    this.layout = [newLayoutItem, ...this.layout];
  }

  groupReportsByCategory() {
    this.groupedReports = this.reportList.reduce((groups: any, report: { category: any; }) => {
      const category = report.category;
      if (!groups[category]) {
        groups[category] = [];
      }
      groups[category].push(report);
      return groups;
    }, {});
    this.groupedKeys = Object.keys(this.groupedReports);

  }

  changeMeeting(type: any) {
    this.meetingType = type;
  }
  changeMeetingPeriod(period: any) {
    this.meetingPeriod = period
  }

  selectCategory(category: string) {
    this.selectedCategory = category;
  }

  backToCategories() {
    this.selectedCategory = null;
  }

  filteredReports() {
    if (this.selectedCategory === null) {
      return [];
    }

    if (!this.searchTerm) {
      return this.groupedReports[this.selectedCategory] || [];
    }

    return this.groupedReports[this.selectedCategory].filter((report: any) =>
      report.reportName.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
  }

  isMenuVisible(id: number): boolean {
    // return this.openMenus.has(id);
    return this.openMenuId === id;
  }

  stopEventPropagation(event: Event) {
    event.preventDefault();
    event.stopPropagation();
  }

  removeItem(id: string) {
    this.layout = this.ktdArrayRemoveItem(this.layout, (item: any) => item.id === id);
  }

  ktdArrayRemoveItem<T>(array: T[], condition: (item: T) => boolean) {
    const arrayCopy = [...array];
    const index = array.findIndex((item) => condition(item));
    if (index > -1) {
      arrayCopy.splice(index, 1);
    }
    return arrayCopy;
  }

  onDescriptionChange(layoutid: number, newContent: any) {
    const index = this.layout.findIndex((layoutObj: { id: any; }) => layoutObj.id === layoutid);
    this.layout[index].content = newContent; // Update the content in the layout array
  }

  onHeadingChange(layoutid: number, newContent: string) {
    const index = this.layout.findIndex((layoutObj: { id: any; }) => layoutObj.id === layoutid);
    this.layout[index].content = newContent;
    // this.layout[index].id = this.layout[index].dashboardConfigId;
    // Update the content in the layout array
  }

  ontitleChange(header: string) {
    this.currentDashboardObj.dashboardName = header;
  }

  showHideDashboardBGConfig(flag: boolean, callfrom: string) {
    this.editDashboard = flag;
    if (!this.editDashboard) {
      this.disableDrag = true;
      this.showBackground = true;
      this.disableResize = true;
      this.disableRemove = true;
      if (callfrom == 'save') {
        this.actualLayout = Object.values(this.layout);
        const dashboardObj = this.currentDashboardObj;
        dashboardObj.dashboardConfig = this.transformLayoutObjToDashboard(this.layout);
        this.savedLayout.emit(dashboardObj);
        // this.dashboardService.updateDashboardByID(dashboardObj).subscribe(response => {
        // });
      } else {
        // this.layout = Object.values(this.actualLayout);
      }

    } else {
      this.disableDrag = false;
      this.showBackground = false;
      this.disableResize = false;
      this.disableRemove = false;
    }
    this.gridBackgroundConfig = {
      ...this.gridBackgroundConfig,
      show: (!this.editDashboard ? 'never' : 'always') as (Required<KtdGridBackgroundCfg>['show'])
    };

  }

  addLayout(item: any) {
    this.addOptions.set(false);
    // if (item === 'Chips') {
    //   this.showCardOptions = true;
    // } else if (item === 'Table') {
    //   this.showTableOptions = true;
    // const newLayoutItem: any = {
    //   id: (this.layout.length + 1).toString(),
    //   x: 0,
    //   y: 0,
    //   w: 30,
    //   h: 2,
    //   minH:2,
    //   minW:15,
    //   reportId:0,
    //   dashboardId: this.tableData.id,
    //   type: 'table',
    //   data: GetTable.data
    // };
    // const dashboard = this.tableData;
    // dashboard.data = this.transformDashboardObjToLayout([newLayoutItem]);
    // // this.dashboardService.addReportstoDashboard(dashboard).subscribe(response => {
    // //   newLayoutItem.dashboardConfigId= response.data.results.dashboardConfigId[0];
    // // });

    // this.layout = [newLayoutItem, ...this.layout];

    // }

  }
  toggleComponent() {
    if (this.currentComponent == 'upcoming') {
      this.currentComponent = "past";
    } else if (this.currentComponent == 'past') {
      this.currentComponent = "document"
    } else {
      this.currentComponent = "upcoming"
    }
  }

  chooseOrganization(event: any) {
    this.selectedOrganization = event;
    this.reload = false;
    this.orgdropdown.set(false);
    this.gridDrillArr = [{
      "colAlias": "ORGCODE",
      "condition": "~eq~",
      "operator": "AND",
      "startBrace": "(",
      "endBrace": ")",
      "conditionValue": this.selectedOrganization.orgCode,
      "conditionType": "",
      "conditionCategory": "",
      "conditionConstant": ""
    }]
    this.ngOnInit();

    // var a = {
    //   loginName: this.loginName,
    //   loginKey: this.loginKey,
    //   templateCode: "SYS_mymeetings_bystatus_2",
    //   gridDrillArr: this.gridDrillArr
    // }


    // this.reportService.getDashBoardMeetingCount(a).subscribe((data: any) => {
    //   this.meetingCountChipData = data.body;
    // })

    // var a = {
    //   loginName: this.loginName,
    //   loginKey: this.loginKey,
    //   templateCode: "SYS_task_count_latest_73",
    //   gridDrillArr: this.gridDrillArr
    // }

    // this.reportService.getDashBoardTaskCount(a).subscribe((data: any) => {
    //   this.taskCountChipData = this.transformTaskData(data.body);
    // })

  }

  getKeyByValue(map: Map<string, string>, value: string): string | undefined {
    for (const [key, val] of map.entries()) {
      if (val == value) {
        return key;
      }
    }
    return undefined; // Return undefined if not found
  }


  onChartClick(event: any, type: string) {
    if (event.seriesType == 'line') {
      var req = {
        rows: 0,
        start: 0,
        loginName: this.loginName,
        loginKey: this.loginKey,
        templateCode: "SYS_drilldownmeetingdata_77",
        gridDrillArr: [{
          "colAlias": "ORGCODE",
          "condition": "~eq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": localStorage.getItem('orgCode'),
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        }, {
          "colAlias": "MEETINGHISSTATUS",
          "condition": "~eq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": this.getKeyByValue(this.globals.meetingStatus, event.seriesName),
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        },
        {
          "colAlias": "MEETING_DATE",
          "condition": "~gteq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": this.getMonthStartAndEnd(event.name).startDate,
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        },
        {
          "colAlias": "MEETING_DATE",
          "condition": "~lteq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": this.getMonthStartAndEnd(event.name).endDate,
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        }


        ]
      }
      const dialogRef = this.dialog.open(DrillDownPreviewComponent, {
        data: { dataSource: 'meeting', req: req },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100vw",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });

    }



    if (event.seriesType == 'bar') {
      var taskReq = {
        rows: 0,
        start: 0,
        loginName: this.loginName,
        loginKey: this.loginKey,
        templateCode: "SYS_drilldowntaskdata_78",
        gridDrillArr: [{
          "colAlias": "ORGCODE",
          "condition": "~eq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": "CHN",
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        },
        {
          "colAlias": "STATUS",
          "condition": "~eq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": event.seriesName == 'Overdue' ? '16' : this.getKeyByValue(this.globals.TaskStatus, event.seriesName),
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        }, {
          "colAlias": "CREATEDON",
          "condition": "~gteq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": this.getMonthStartAndEnd(event.name).startDate,
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        },
        {
          "colAlias": "CREATEDON",
          "condition": "~lteq~",
          "operator": "AND",
          "startBrace": "(",
          "endBrace": ")",
          "conditionValue": this.getMonthStartAndEnd(event.name).endDate,
          "conditionType": "",
          "conditionCategory": "",
          "conditionConstant": ""
        }

        ]
      }
      // this.reportService.getDrilldownTaskData(taskReq).subscribe((data: any) => {
      // })
      if (event.seriesName == 'OverDue') {
        taskReq.templateCode = "SYS_drilldown_overdue_task_86"
      }
      const dialogRef = this.dialog.open(DrillDownPreviewComponent, {
        data: { dataSource: 'task', req: taskReq },
        panelClass: ['animate__animated', 'animate__slideInLeft'],
        disableClose: true,
        position: {
          left: "0%"
        },
        maxWidth: "100vw",
        maxHeight: "100vh",
        width: "50%",
        height: "100vh"
      })
      const mediumDialogSubscription = this.isMedium.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('70vw', '100vh');
        }
      })
      const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        } else {
          dialogRef.updateSize('calc(100% - 50px)', '100vh');
        }
      });
      const smallSubscription = this.isSmall.subscribe(size => {
        if (size.matches) {
          dialogRef.updateSize('100vw', '100vh');
        }
      })
      dialogRef.afterClosed().subscribe((data) => {
        mediumDialogSubscription.unsubscribe()
        smallSubscription.unsubscribe()
        smallDialogSubscription.unsubscribe()
      });
    }














    // var cardSettings = {
    // 				"id": "0",
    // 				"theme": "blue",
    // 				"noOfColumns": 6,
    // 				"checkboxSelect": "true",
    // 				"actionItem": "true",
    // 				"actionItemData": [
    // 				  {
    // 					"actionId": "1",
    // 					"actionIcon": "edit",
    // 					"actionName": "Edit",
    // 					"actionTooltip": "Edit",
    // 					"showIcon": "true"
    // 				  },
    // 				  {
    // 					"actionId": "null",
    // 					"actionIcon": "delete",
    // 					"actionName": "Delete",
    // 					"actionTooltip": "Delete",
    // 					"showIcon": "true"
    // 				  },
    // 				  {
    // 					"actionId": "null",
    // 					"actionIcon": "lock_reset",
    // 					"actionName": "Reset Password",
    // 					"actionTooltip": "Reset password",
    // 					"showIcon": "true"
    // 				  },
    // 				  {
    // 					"actionId": "null",
    // 					"actionIcon": "reset_tv",
    // 					"actionName": "Reset eSign",
    // 					"actionTooltip": "Reset",
    // 					"showIcon": "true"
    // 				  },
    // 				  {
    // 					"actionId": "null",
    // 					"actionIcon": "task_alt",
    // 					"actionName": "Activate User",
    // 					"actionTooltip": "Activate User",
    // 					"showIcon": "true"
    // 				  }
    // 				],
    // 				"filter": "true",
    // 				"search": "true",
    // 				"pagination": "true",
    // 				"pin": "false",
    // 				"pinOnly": "false",
    // 				"commonTag": "[]",
    // 				"globalActionItem": [
    // 				  {
    // 					"add": "false",
    // 					"delete": "true"
    // 				  }
    // 				],
    // 				"globalSearch": "true",
    // 				"columnManager": "true",
    // 				"columns": [
    // 				  {
    // 					"columnsOnGrid": "true",
    // 					"columnCustomization": "true",
    // 					"mandColumns": "true",
    // 					"type": "string",
    // 					"showColumn": "true",
    // 					"list": "null",
    // 					"textAlign": "left",
    // 					"showFilter": "true",
    // 					"filterData": "[]",
    // 					"colorCondition": "[]",
    // 					"sequenceNumber": "0",
    // 					"ColName": "checkbox",
    // 					"label": "checkbox",
    // 					"dataFormat": ""
    // 				  },
    // 				  {
    // 					"columnsOnGrid": "true",
    // 					"columnCustomization": "true",
    // 					"mandColumns": "true",
    // 					"type": "string",
    // 					"showColumn": "true",
    // 					"list": "null",
    // 					"textAlign": "left",
    // 					"showFilter": "true",
    // 					"filterData": "[]",
    // 					"colorCondition": "[]",
    // 					"sequenceNumber": "1",
    // 					"ColName": "loginName",
    // 					"label": "User Name",
    // 					"dataFormat": "link"
    // 				  },
    // 				  {
    // 					"columnsOnGrid": "true",
    // 					"columnCustomization": "true",
    // 					"mandColumns": "true",
    // 					"type": "string",
    // 					"showColumn": "true",
    // 					"list": "null",
    // 					"textAlign": "left",
    // 					"showFilter": "true",
    // 					"filterData": "[]",
    // 					"colorCondition": "[]",
    // 					"sequenceNumber": "2",
    // 					"ColName": "firstName",
    // 					"label": "First Name",
    // 					"dataFormat": ""
    // 				  },
    // 				  {
    // 					"columnsOnGrid": "true",
    // 					"columnCustomization": "true",
    // 					"mandColumns": "true",
    // 					"type": "string",
    // 					"showColumn": "true",
    // 					"list": "null",
    // 					"textAlign": "left",
    // 					"showFilter": "true",
    // 					"filterData": "[]",
    // 					"colorCondition": "[]",
    // 					"sequenceNumber": "3",
    // 					"ColName": "lastName",
    // 					"label": "Last Name",
    // 					"dataFormat": ""
    // 				  },
    // 				  {
    // 					"columnsOnGrid": "true",
    // 					"columnCustomization": "true",
    // 					"mandColumns": "true",
    // 					"type": "string",
    // 					"showColumn": "true",
    // 					"list": "null",
    // 					"textAlign": "left",
    // 					"showFilter": "true",
    // 					"filterData": "[]",
    // 					"colorCondition": "[]",
    // 					"sequenceNumber": "4",
    // 					"ColName": "email",
    // 					"label": "Email",
    // 					"dataFormat": ""
    // 				  },
    // 				  {
    // 					"columnsOnGrid": "true",
    // 					"columnCustomization": "true",
    // 					"mandColumns": "true",
    // 					"type": "string",
    // 					"showColumn": "true",
    // 					"list": "null",
    // 					"textAlign": "left",
    // 					"showFilter": "true",
    // 					"filterData": "[]",
    // 					"colorCondition": "[]",
    // 					"sequenceNumber": "5",
    // 					"ColName": "userStatusMessage",
    // 					"label": "Reason for Inactivity",
    // 					"dataFormat": ""
    // 				  },
    // 				  {
    // 					"columnsOnGrid": "true",
    // 					"columnCustomization": "true",
    // 					"mandColumns": "true",
    // 					"type": "string",
    // 					"showColumn": "true",
    // 					"list": "null",
    // 					"textAlign": "left",
    // 					"showFilter": "true",
    // 					"filterData": "[]",
    // 					"colorCondition": "[]",
    // 					"sequenceNumber": "6",
    // 					"ColName": "tableActionItems",
    // 					"label": "Action Items",
    // 					"dataFormat": ""
    // 				  }
    // 				],
    // 				"data": [
    // 				  {
    // 					"pk_userID": 484,
    // 					"loginName": "A.Administrator",
    // 					"firstName": "Muthu",
    // 					"lastName": "Krish",
    // 					"email": "vjayaprakash@chn.aithent.com",
    // 					"phone": "+918072484263",
    // 					"userIsActive": 1,
    // 					"user_AccIsActive": 1,
    // 					"userAccountStatus": 1,
    // 					"userStatusMessage": "Login attempts failed.",
    // 					"groups": null,
    // 					"contentType": null
    // 				  },
    // 				  {
    // 					"pk_userID": 33423,
    // 					"loginName": "Anitha",
    // 					"firstName": "Anitha",
    // 					"lastName": "Ani",
    // 					"email": "anitha@gmail.com",
    // 					"phone": "9978989979",
    // 					"userAccountStatus": 4,
    // 					"userStatusMessage": "Password has expired.",
    // 					"groups": null,
    // 					"contentType": null
    // 				  },
    // 				  {
    // 					"pk_userID": 33524,
    // 					"loginName": "ooviya",
    // 					"firstName": "Muthu",
    // 					"lastName": "Krishnan",
    // 					"email": "testmail@gmail.com",
    // 					"phone": "9090608080",
    // 					"userIsActive": 1,
    // 					"user_AccIsActive": 1,
    // 					"userAccountStatus": 4,
    // 					"userStatusMessage": "Password has expired.",
    // 					"groups": null,
    // 					"contentType": null
    // 				  },
    // 				  {
    // 					"pk_userID": 33701,
    // 					"loginName": "Admin353",
    // 					"firstName": "Admin",
    // 					"lastName": "AD",
    // 					"email": "new@user.com",
    // 					"phone": "9908909088",
    // 					"userIsActive": 1,
    // 					"user_AccIsActive": 1,
    // 					"userAccountStatus": 4,
    // 					"userStatusMessage": "Password has expired.",
    // 					"groups": null,
    // 					"contentType": null
    // 				  },
    // 				  {
    // 					"pk_userID": 33728,
    // 					"loginName": "annisi1",
    // 					"firstName": "Anny",
    // 					"lastName": "Bent",
    // 					"email": "eoviya@chn.aithent.com",
    // 					"phone": "9090608080",
    // 					"userAccountStatus": 0,
    // 					"userStatusMessage": "Unknown status. Please contact support.",
    // 					"groups": null,
    // 					"contentType": null
    // 				  },
    // 				  {
    // 					"pk_userID": 33730,
    // 					"loginName": "Prenika",
    // 					"firstName": "Muthu",
    // 					"lastName": "Krishnan",
    // 					"email": "eoviya@chn.aithent.com",
    // 					"phone": "9199423172",
    // 					"user_AccIsActive": 1,
    // 					"userAccountStatus": 1,
    // 					"userStatusMessage": "Login attempts failed.",
    // 					"groups": null,
    // 					"contentType": null
    // 				  }
    // 				]
    // 			  }
    // const dialogRef = this.dialog.open(AdcTableComponent, {
    //             data: {dataSource : cardSettings , noData : "false" },
    //             panelClass: ['animate__animated','animate__slideInLeft'],
    //                     disableClose: true,
    //                     position : {
    //                       left : "0%"
    //                     },
    //                     maxWidth : "100vw",
    //                     maxHeight: "100vh",
    //                     width: "50%",
    //                     height : "100vh"
    //           })
    //           const mediumDialogSubscription = this.isMedium.subscribe(size => {
    //             if(size.matches){
    //               dialogRef.updateSize('70vw','100vh');
    //             }
    //           })
    //           const smallDialogSubscription = this.isExtraSmall.subscribe(size => {
    //             if (size.matches) {
    //               dialogRef.updateSize('100vw', '100vh');
    //             } else {
    //               dialogRef.updateSize('calc(100% - 50px)', '100vh');
    //             }
    //           });
    //           const smallSubscription = this.isSmall.subscribe(size => {
    //             if(size.matches){
    //               dialogRef.updateSize('100vw', '100vh');
    //             }
    //           })
    //           dialogRef.afterClosed().subscribe((data) => {
    //             mediumDialogSubscription.unsubscribe()
    //             smallSubscription.unsubscribe()
    //             smallDialogSubscription.unsubscribe()
    //           });
  }



  getMonthStartAndEnd(dateString: string) {
    const parsedDate = new Date(Date.parse(dateString));

    if (isNaN(parsedDate.getTime())) {
      throw new Error('Invalid date format. Please use a format like "jan 2025"');
    }

    // Get first and last day of the month
    const startDate = new Date(parsedDate.getFullYear(), parsedDate.getMonth(), 1);
    const endDate = new Date(parsedDate.getFullYear(), parsedDate.getMonth() + 1, 0);
    // Format date to 'mm/dd/yyyy'
    const formatDate = (date: Date) =>
      `${(date.getMonth() + 1).toString().padStart(2, '0')}/` +
      `${date.getDate().toString().padStart(2, '0')}/` +
      `${date.getFullYear()}`;

    // return formatDate(startDate)+" and "+formatDate(endDate);
    return {
      startDate: formatDate(startDate),
      endDate: formatDate(endDate)
    }
  }


  onMeetingStatusClick(event: { status: string; count: number }) {
    console.log('Meeting Clicked:', event);
  }

  onTaskStatusClick(event: { status: string; count: number }) {
    console.log('Task Clicked:', event);
  }


  btnActivate(btn: any) {
    this.btnActive = btn;
  }
  activeday: any = 'Today';
  dayIdx: number = 0;
  cardIndex!: number;
  setActiveData(data: any, i: number) {
    data.map((item: any, j: number) => {
      if (j === i) {
        item.active = true;
      } else {
        item.active = false;
      }
    })
  }

  getCardBorder(name: any) {
    switch (name) {
      case 'Task':
        return '#F68537'
      case 'Meeting':
        return '#B13BFF'
      case 'Frequently Cancelled':
        return '#B22222'
      case 'Followup Meeting':
        return '#84AE92'
      default:
        return '#0065F8'
    }
  }


  getMeetingDetail(event: any, i: number) {
    console.log('detail called')
  }

  //dashboard sample

  selectedFilter: 'today' | 'week' | 'month' = 'today';

  meetingData = {
    today: {
      myMeetings: [
        { label: 'Yet To Schedule', count: 2 },
        { label: 'In Progress', count: 1 }
      ],
      otherMeetings: [
        { label: 'Yet To Schedule', count: 3 },
        { label: 'In Progress', count: 4 }
      ]
    },
    week: {
      myMeetings: [
        { label: 'Yet To Schedule', count: 5 },
        { label: 'In Progress', count: 3 }
      ],
      otherMeetings: [
        { label: 'Yet To Schedule', count: 6 },
        { label: 'In Progress', count: 2 }
      ]
    },
    month: {
      myMeetings: [
        { label: 'Yet To Schedule', count: 10 },
        { label: 'In Progress', count: 8 }
      ],
      otherMeetings: [
        { label: 'Yet To Schedule', count: 12 },
        { label: 'In Progress', count: 7 }
      ]
    }
  };

  setFilter(filter: 'today' | 'week' | 'month') {
    this.selectedFilter = filter;
  }
}



const defaultBackgroundConfig: Required<Omit<KtdGridBackgroundCfg, 'show'>> = {
  borderColor: '#ffa72678',
  gapColor: 'transparent',
  rowColor: 'transparent',
  columnColor: 'transparent',
  borderWidth: 1,
};
